import { Button, Card, Typography } from "@material-tailwind/react";
import React from "react";
import { LIST_CYLINDER_WEIGHT_TABLE_HEAD } from "../../variables/constants";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function CylinderReportTable(props) {
  const handleDownload = () => {
    const isWeighingScale = props.cylinderList?.[0]?.ws_status == 1;

    const data = props.cylinderList.map((cylinder) => {
      if (isWeighingScale) {
        return [
          moment(cylinder.createdAt).format("DD/MM/YYYY HH:mm"),
          cylinder.cylndr_insert_status === 1
            ? Number(cylinder.cylinder_weight) ?? "-"
            : cylinder.cylinder_weight,
          cylinder.cylndr_insert_status === 1
            ? Number(cylinder.empty_weight) ?? "-"
            : cylinder.empty_weight,
          Number(cylinder.net_weight),
          cylinder.returned_weight !== null
            ? cylinder.returned_weight !== 0
              ? Number(cylinder.returned_weight)
              : Number(cylinder.returned_weight)
            : "-",
          cylinder.lpg_consumed !== null
            ? cylinder.lpg_consumed !== 0
              ? Number(cylinder.lpg_consumed)
              : Number(cylinder.lpg_consumed)
            : "-",
          cylinder.resedue !== null
            ? cylinder.resedue !== 0
              ? Number(cylinder.resedue)
              : Number(cylinder.resedue)
            : "-",
          "Manifold" + cylinder.manifold,
        ];
      } else {
        return [
          moment(cylinder.createdAt).format("DD/MM/YYYY HH:mm"),
          cylinder.lpg_consumed / cylinder.net_weight || "-",
          Number(cylinder.net_weight),
          cylinder.lpg_consumed || "-",
          "Manifold" + cylinder.manifold,
        ];
      }
    });

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([
      props.cylinderList?.[0]?.ws_status == 1
        ? LIST_CYLINDER_WEIGHT_TABLE_HEAD
        : [
            "Date",
            "No. of Cylinders",
            "Net weight",
            "LPG consumed",
            "Manifold",
          ],
      ...data,
    ]);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cylinder Weight Report");

    // Convert workbook to binary string
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Save the file
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "cylinder_weight_report.xlsx"
    );
  };

  return (
    <div>
      <div className="mt-5 md:mt-8">
        <div className="flex justify-between items-center mb-4">
          <div>
            <p className="text-2xl font-bold text-black pb-2">
              Cylinder Weight Report
            </p>
            <p className="text-black font-semibold text-2xl">
              Branch: {props.cylinderList?.[0]?.branch_name}
            </p>
          </div>

          {props.cylinderList?.length > 0 && (
            <Button
              onClick={handleDownload}
              className="font-poppins font-medium tracking-wider bg-[#03438D]"
            >
              Download
            </Button>
          )}
        </div>

        {props.cylinderList?.length > 0 ? (
          <Card
            className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidden"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
            }}
          >
            <table className="w-full min-w-max table-auto text-center">
              <thead>
                {props.cylinderList?.[0]?.ws_status == 1 ? (
                  <tr>
                    {LIST_CYLINDER_WEIGHT_TABLE_HEAD.map((head) => (
                      <th
                        key={head}
                        className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                      >
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins text-white font-semibold uppercase"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                ) : (
                  <tr>
                    {[
                      "Date",
                      "No. of Cylinders",
                      "Net weight",
                      "LPG consumed",
                      "Manifold",
                    ].map((head) => (
                      <th
                        key={head}
                        className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                      >
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins text-white font-semibold uppercase"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                  </tr>
                )}
              </thead>
              <tbody>
                {props.cylinderList.map((cylinder, index) => {
                  return props.cylinderList?.[0]?.ws_status == 1 ? (
                    <tr key={index}>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {moment(cylinder.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins text-sm font-semibold`}
                        >
                          {cylinder.cylndr_insert_status === 1
                            ? cylinder.cylinder_weight ?? "-"
                            : cylinder.cylinder_weight}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold"
                        >
                          {cylinder.cylndr_insert_status === 1
                            ? cylinder.empty_weight ?? "-"
                            : cylinder.empty_weight}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.net_weight}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.returned_weight !== null
                            ? cylinder.returned_weight !== 0
                              ? cylinder.returned_weight
                              : cylinder.returned_weight
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.lpg_consumed !== null
                            ? cylinder.lpg_consumed !== 0
                              ? cylinder.lpg_consumed
                              : cylinder.lpg_consumed
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.resedue !== null
                            ? cylinder.resedue !== 0
                              ? cylinder.resedue
                              : cylinder.resedue
                            : "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold"
                        >
                          Manifold {cylinder.manifold}
                        </Typography>
                      </td>
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {moment(cylinder.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold gap-2 text-sm text-black"
                        >
                          {cylinder.lpg_consumed / cylinder.net_weight || "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.net_weight}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className={`font-poppins font-semibold`}
                        >
                          {cylinder.lpg_consumed || "-"}
                        </Typography>
                      </td>
                      <td className="p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins font-semibold"
                        >
                          Manifold {cylinder.manifold}
                        </Typography>
                      </td>
                    </tr>
                  );
                  // </div>
                })}
              </tbody>
            </table>
          </Card>
        ) : (
          <div className="text-center h-[50vh] flex flex-col justify-center items-center">
            <p className="font-semibold text-xl sm:text-3xl">
              Oops! No Data Found...
            </p>
            <p className="text-sm mt-2 ">
              Looks like we couldn't find any data.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CylinderReportTable;
